<template>
  <div>
    <main-layout>
      <v-container>
        <v-layout wrap>
          <v-flex sm6>
            <h2 class='mb-4'>
              {{ $t('messenger_ads_simulator_json') }}
              <a href='https://blog.zwiz.app/messenger-ads-simulator/' target='blank'
              ><i style='font-size: 22px; color: #ed1e79;' class='fas fa-question-circle'></i
              ></a>
            </h2>
          </v-flex>
          <v-flex sm6 class='text-xs-right'>
            <template>
              <TransferJson :all_count="all_count"></TransferJson>
            </template>
            <v-btn outline color='primary' :loading='loadingAdd' @click='openLinkAds'>{{
                $t('go_to_ads_manager')
              }}
            </v-btn>
          </v-flex>
        </v-layout>
        <div>
          <div style='margin-bottom: 10px;' class='broadcasts'>
            <a
              v-if='getPackageConfig().adsSimulator !== total_count'
              href='javascript:void(0);'
              v-show='!isShow'
              @click="onAddJson"
            >
              <div class='add-broadcast text-xs-center mb-2'>
                <i class='fa fa-plus middle'></i>
                {{ $t('add_template_messenger_ads') }}
              </div>
            </a>

            <div class='intent-item z-border-red' v-if='isShow' style='padding: 10px 15px 0px;'>
              <form>
                <div class='form-control pa-1' :class="{ 'has-error': errors.has('name') }">
                  <label>{{ $t('name') }}</label>
                  <input
                    :data-vv-as="$t('name')"
                    v-model='adsItem.message_name'
                    v-validate="'required'"
                    name='name'
                    class='form-control'
                    type='text'
                  />
                  <span class='text-error' v-if="errors.has('name')">{{
                      errors.first('name')
                    }}</span>
                </div>
                <ads-simulator-preview
                  v-model='adsItem.a_val'
                  :quickReply.sync='adsItem.quick_reply'
                ></ads-simulator-preview>
                <div class='text-xs-center mt-2 mb-2'>
                  <v-btn outline color='grey' :loading='loadingAdd' @click='close'>{{
                      $t('cancel')
                    }}
                  </v-btn>
                  <v-btn depressed color='primary' :loading='loadingAdd' @click='saveIntentAds'>{{
                      $t('Save')
                    }}
                  </v-btn>
                </div>
              </form>
            </div>
          </div>

          <div
            v-show='!isShow'
            style='background: #FFFFFF 0% 0% no-repeat padding-box; border-radius: 26px; padding: 20px;'
          >
            <v-layout wrap>
              <v-flex xs12 sm6 class='form-control' style='display: inherit;'>
                <div class='input-icons'>
                  <i class='fa fa-search icon'></i>
                  <input
                    @keyup.enter='
                      pageNumber = 1
                      getAdsSimulator()
                    '
                    type='text'
                    v-model='search'
                    class='form-control'
                    :placeholder="$t('search_ads_template_name')"
                    style='margin-bottom: 10px'
                  />
                  <v-btn v-show='search.length > 0' @click='clearSearch' icon class='icon-close'>
                    <i class='fa fa-close'></i
                    ></v-btn>
                </div>
                <v-btn
                  @click='
                    pageNumber = 1
                    getAdsSimulator()
                  '
                  color='primary'
                >
                  {{ $t('Search') }}
                </v-btn>
              </v-flex>
              <v-flex xs12 sm6 class='text-xs-right' v-if='pageCount > 1'>
                <v-pagination
                  class='mb-2'
                  :total-visible='15'
                  v-model='pageNumber'
                  :length='pageCount'
                  @input='changePage'
                ></v-pagination>
              </v-flex>
            </v-layout>
            <div v-if='loading' class='spinner text-xs-center mt-5'>
              <img class='z-loop' src='/static/img/assets/loading/z-loop.png' alt='loading' />
            </div>
            <div v-else
              class='intent-item z-border-red'
              style='padding: 10px 15px 10px;'
              v-for='(item, index) in data'
              :key='index'
            >
              <v-layout wrap>
                <v-flex xs12 sm6 class='pa-2'>
                  <h3>{{ item.message_name }}</h3>
                </v-flex>
                <v-flex xs12 sm6 class='text-xs-right'>
                  <v-btn
                    small
                    class='ma-1'
                    v-clipboard:copy='jsonMessagesAds(item.a_val, item.quick_reply)'
                    v-clipboard:success='onCopy'
                    v-clipboard:error='onCopyError'
                    color='primary'
                  >
                    <v-icon class='mr-2'>content_copy</v-icon>
                    {{ $t('copy_json') }}
                  </v-btn>
                  <v-btn
                    fab
                    outline
                    color='primary'
                    class='extra-small ma-1'
                    @click='editIntent(item)'
                  >
                    <i class='fas fa-pencil-alt'></i>
                  </v-btn>
                  <v-btn
                    fab
                    outline
                    :loading='loadingDelete'
                    color='primary'
                    class='extra-small ma-1'
                    @click='deleteAdsSimulator(item)'
                  >
                    <i class='fa fa-trash middle'></i>
                  </v-btn>
                </v-flex>
              </v-layout>
              <div class='text-xs-right mt-3' @click='item.expand = !item.expand'>
                <span
                  :class="{
                    'fas fa-chevron-down': !item.expand,
                    'fas fa-chevron-up': item.expand
                  }"
                  style='font-size: 1.5em; margin-right: 5px; cursor: pointer;'
                  class='primary--text'
                ></span>
              </div>
              <ads-simulator-preview
                :isNotShowJson='true'
                v-if='item.expand'
                :isOnlyJson='true'
                v-model='item.a_val'
                :quickReply.sync='item.quick_reply'
              ></ads-simulator-preview>
            </div>
            <div class='text-xs-right' v-if='pageCount > 1 && !loading'>
              <v-pagination
                class='mt-1'
                :total-visible='15'
                v-model='pageNumber'
                :length='pageCount'
                @input='changePage'
              ></v-pagination>
            </div>
          </div>
        </div>
      </v-container>
      <v-snackbar v-model='showCopy' :timeout='6000' color='green' :top='true'
      >{{ $t('Copied') }}!
      </v-snackbar
      >
    </main-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AdsSimulatorPreview from './AdsSimulatorPreview'
import TransferJson from './TransferJson.vue'

export default {
  data() {
    return {
      isShow: false,
      data: [],
      adsItem: { quick_reply: '', a_val: [[]] },
      loadingAdd: false,
      loading: false,
      loadingDelete: false,
      showCopy: false,
      pageNumber: 1,
      pageCount: 1,
      limit: 10,
      offset: 0,
      search: '',
      total_count: 0,
      all_count: 0,
      max_json: 0
    }
  },
  components: {
    AdsSimulatorPreview,
    TransferJson
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    const vm = this

    let package_config = vm.getPackageConfig()
    vm.max_json = package_config.adsSimulator

    if (vm.selectedBot.theme == 'ecommercebasic') {
      vm.$store.dispatch('loadCategory').then(function() {
        vm.$store.dispatch('loadProducts')
      })
    }
    vm.getAdsSimulator()
  },
  methods: {
    onAddJson(){
      console.log("onAddJson");
      const vm = this
      // *******************************************************
      let account_packages = this.getPackageType()
      if ( account_packages.includes('enterprise') ) {
        // unlimited
      } else if ( account_packages.includes('business') || account_packages.includes('advanced') ) {
        if (this.all_count >= this.max_json) {
          this.$swal
            .fire({
              html: `<b class="intentmax"> ${this.$t('template_you_have_reached_the_limit_for_the_package')}${this.$t('please_contact_us')}</b>`,
              confirmButtonText: this.$t('contact_us'),
              confirmButtonColor: this.$vuetify.theme.primary
            })
            .then(result => {
              if (result.value) {
                window.location.assign('https://www.facebook.com/messages/t/zwizai')
              }
            })
          return false
        }
      } else {
        if (this.all_count >= this.max_json) {
          this.$swal
            .fire({
              html: `<b class="intentmax"> ${this.$t('template_you_have_reached_the_limit_for_the_package')}${this.$t('upgrade_to_advanced_now')}</b>`,
              confirmButtonText: this.$t('Upgrade now'),
              confirmButtonColor: this.$vuetify.theme.primary
            })
            .then(result => {
              if (result.value) {
                this.$router.push('Upgrade').catch(() => {})
              }
            })
          return false
        }
      }
      vm.isShow = true
      vm.adsItem = { quick_reply: '', a_val: [[]] }
    },
    async close() {
      const vm = this
      vm.isShow = false
    },
    openLinkAds() {
      window.open('https://www.facebook.com/ads/manager/accounts', '_blank')
    },
    async getAdsSimulator() {
      const vm = this
      vm.loading = true
      var res = await api.getAdsSimulator({
        pageId: vm.selectedBot.pageid,
        params: {
          limit: vm.limit,
          offset: vm.offset,
          sort_type: 'desc',
          sort_by: 'message_name',
          search: vm.search || ''
        }
      })
      if (res.success) {
        vm.data = []
        res.result.map(item => {
          item.a_val = JSON.parse(item.a_val)
          item.expand = false
          vm.data.push(item)
        })
        vm.all_count = res.all_count
        vm.total_count = res.total_count
        vm.pageCount = Math.ceil(vm.total_count / vm.limit)
        vm.loading = false
      }
    },
    changePage() {
      var vm = this
      vm.offset = (vm.pageNumber - 1) * vm.limit
      vm.getAdsSimulator()
    },

    async saveIntentAds() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        let params = {
          pageId: vm.selectedBot.pageid,
          body: {
            message_name: vm.adsItem.message_name,
            a_type: 'json',
            a_val: JSON.stringify(vm.adsItem.a_val),
            quick_reply: vm.adsItem.quick_reply || '',
            content_json: '[[]]'
          }
        }
        vm.loadingAdd = true
        let res = null
        if (vm.adsItem.id) {
          params.adsId = vm.adsItem.id
          res = await api.editAdsSimulator(params)
        } else {
          res = await api.updateAdsSimulator(params)
        }
        if (res.success) {
          vm.isShow = false
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `Ads ${vm.adsItem.message_name} ${
              vm.adsItem.id ? 'ถูกแก้ไขแล้ว' : 'ถูกเพิ่มแล้ว'
            }`,
            type: 'success'
          })

          vm.getAdsSimulator()

          vm.loadingAdd = false
        } else {
          if (res.data && !res.data.success) {
            vm.$swal.fire({
              title: vm.$t('error'),
              text: vm.$t(res.data.message),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              reverseButtons: true
            })
          }

          vm.loadingAdd = false
        }
      }
    },
    editIntent(item) {
      const vm = this
      const setData = JSON.stringify(item)
      vm.adsItem = JSON.parse(setData)
      vm.isShow = true
    },
    async deleteAdsSimulator(item) {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete {name}?', {
          name: 'Ads ' + item.message_name
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loadingDelete = true
        var res = await api.deleteAdsSimulator({
          pageId: vm.selectedBot.pageid,
          adsId: item.id
        })
        if (res.success) {
          if (vm.data.length > 0) {
            vm.data = vm.data.filter(function(value) {
              return value.id !== item.id
            })
          }
          vm.loadingDelete = false
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `Ads ${item.message_name} ถูกลบแล้ว`,
            type: 'success'
          })
          vm.total_count = vm.total_count - 1
        } else {
          vm.loadingDelete = false
        }
      }
    },
    jsonMessagesAds(messages, quick_reply) {
      const vm = this
      let setMessages = JSON.stringify(messages[0])
      setMessages = JSON.parse(setMessages)
      let quick_replies = []
      let result = []
      setMessages.map(item => {
        item.template_type = item.type
        item.elements = item.data
        delete item.type
        delete item.data
        delete item.altText
        if (item.buttons && item.buttons.length > 0) {
          item = vm.replaceShop(item.buttons)
        }
        if (item.elements && item.elements.length > 0) {
          item.elements.map(item => {
            item = vm.replaceShop(item.buttons)
          })
        }

        if (quick_reply && quick_reply !== '') {
          quick_replies = quick_reply.split(',')
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {
          }
        }
      })

      let replies = JSON.stringify(result)
      replies = JSON.parse(replies)
      replies.map(item => {
        item.title = item.text
        item.payload = item.text
        item.content_type = 'text'
        delete item.text
      })
      let json = {}
      if (setMessages[0] && setMessages[0].template_type === 'text') {
        json.message = { text: setMessages[0].text }
      } else if (
        setMessages[0] &&
        (setMessages[0].template_type === 'button' || setMessages[0].template_type === 'generic')
      ) {
        delete setMessages[0].custom_type
        json.message = {
          attachment: {
            type: 'template',
            payload: setMessages[0]
          }
        }
      } else if (setMessages[0] && setMessages[0].template_type === 'image') {
        json.message = {
          attachment: {
            type: 'image',
            payload: { url: setMessages[0].image_url }
          }
        }
      }

      if (json.message && replies.length > 0) {
        json.message['quick_replies'] = replies
      }

      return JSON.stringify(json, null, 4)
    },
    replaceShop(arrayData) {
      const vm = this
      if (arrayData && arrayData.length > 0) {
        arrayData.map(item => {
          if (item && item.type !== 'postback') {
            item.url = item.url
              ? item.url.includes('{shopurl}')
                ? item.url.replace(
                  '{shopurl}',
                  `https://shopv2.zwiz.app/ecommerce/${vm.selectedBot.pageid}?`
                )
                : item.url.replace(
                  '{salepage}',
                  `https://shopv2.zwiz.app/salepage/${vm.selectedBot.pageid}?`
                )
              : ''
          }
        })
      }
      return arrayData
    },
    onCopy() {
      const vm = this
      vm.showCopy = true
    },
    onCopyError(error) {
      console.log(error)
    },
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.getAdsSimulator()
    }
  }
}
</script>
<style lang='scss' scoped>
.intentmax {
  font-size: 22px;
}

.input-icons {
  display: contents;

  i {
    position: absolute;
  }

  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }

  .icon {
    padding: 16px;
    min-width: 50px;
  }

  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/AdsSimulator/AdsSimulator.vue